import notie from "notie"

import Products from "./Products/Products"
import product from "./product/product"
import Cart from "./cart/Cart"
import Typeahead from "./Typeahead"
import Filter from "./filter/Filter"
import Auth from "./Auth/Auth"
import CategoryModel from "./CategoryModel"
import OrderlistService from "./OrderlistService"
import Analytics from "./Analytics"
import ProductModel from "./ProductModel"
import _ from "lodash"
import Signal from "./Signal"
import store from "store"
import $fetch from "./$fetch"
import app from "app.controller"

// console.time( "bench:shop ready" )
export default class Api {
  constructor( config ) {
    this.config = config
    window.__bshop_config = config

    // default models
    this.ProductModel = config.ProductModel || ProductModel
    this.CategoryModel = config.CategoryModel || CategoryModel
    this.SessionModel = config.SessionModel || false

    this.model = {}
    this.model.Product = ProductModel
    this.model.Category = CategoryModel

    this.typeahead = new Typeahead( {
      config,
      shop: this
    } )

    this.events = {}
    this.events.login = new Signal()
    this.events.logout = new Signal()
    this.events.authentified = new Signal()
    this.events.authentified.memorize = true
    this.events.loaded = new Signal()
    this.events.loaded.memorize = true
    this.mail = mail

    this._prepareCategories( config )

    let auth = new Auth( {
      shop  : this,
      signal: this.events.authentified,
      config
    } )

    this.login = ( { user, password } ) => auth.auth( {
      user,
      password
    } )

    this.logout = () => {
      return auth.logout()
    }

    this.whoami = function () {
      console.log( `whoami!` )
      return auth.whoami()
    }

    this.service = {}
    this.service.request = ( id, form ) => {
      return fetch( `${this.config.API}service/request?id=${id}`, {
        method     : "POST",
        credentials: "include",
        headers    : {
          "Accept"      : "application/json",
          "Content-Type": "application/json;charset=utf-8"
        },
        body       : JSON.stringify( form )
      } )
    }

    this.service.params = ( files ) => {
      let formData = new FormData()
      _.each( files, file => formData.append( `file-${file.name}`, file ) )
      return fetch( `${this.config.API}service/params`, {
        method: "POST",
        body  : formData
      } )
        .catch( e => {
          console.warn( e )
          return false
        } )
    }

    this.session = false
    this.hasSession = function () {
      return this.session || false
    }

    this.hasRole = function ( role ) {
      return this.session && this.session.user && _.includes( this.session.user.roles, role )
    }

    this.Filter = Filter

    // CMS access
    this.page = this.cms = function ( slug ) {
      let url = this.config.CMS + "pages?slug=" + slug + "&lang=" + app._currentLanguage
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .then( page => page[ 0 ] )
        .catch( err => console.error( "Fehler beim Laden der CMS Inhalte:", slug, err ) )
    }

    this.form = this.cms = function ( slug ) {
      let url = this.config.CMS + "bshop-form?slug=" + slug + "&lang=" + app._currentLanguage
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .catch( err => console.error( "CMS Module (Form) Error", err ) )
    }

    this.post = function ( slug ) {
      //http://bshopdemo.trend-soft.de/wp/wp-json/wp/v2/
      let url = this.config.CMS + "posts?slug=" + slug + "&lang=" + app._currentLanguage
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .then( page => page[ 0 ].acf )
    }

    this.getCMSModule = function ( slug ) {
      return this.getCMSContent( slug )
        .then( page => page[ 0 ].acf )
    }

    this.getCMSContent = function ( slug ) {
      let url = this.config.CMS + "shop?slug=" + slug + "&lang=" + app._currentLanguage
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .catch( err => console.error( "CMS Module Error", err ) )
    }

    this.getConfig = function () {
      let url = `${this.config.BASE}wp/wp-json/acf/v3/options/bshop-config?lang=${app._currentLanguage}`
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .then( response => response.acf || {} )
        .then( ( config = {} ) => {
          console.log( `received shop config:`, config )
          if ( config.blacklist ) {
            let c = {}
            config.blacklist.forEach( entry => {
              let list = entry.brands_blacklist.trim()
                .split( "," )
              c[ entry.country_code ] = list
            } )
            config.blacklist = c
          }

          config.brandById = {}
          if ( config.brands ) {
            config.brands.forEach( brand => {
              config.brandById[ brand.title ] = brand
            } )
          }

          Object.assign( this.config, config )
          return config
        } )
    }

    this.getFrontPage = function () {
      let url = `${this.config.CMS}pages?slug=home&lang=${app._currentLanguage}`
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .then( response => response[ 0 ] )
        .then( page => {
          return page
        } )
        .catch( err => console.error( "Fehler beim Laden der CMS Inhalte:", url, err ) )
    }
    this.getFrontPageWithOptions = function () {
      let url = `${this.config.CMS}options/page_on_front`
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .then( options => options.page_on_front )
        .then( pageId => {
          let frontpageUrl = `${this.config.CMS}pages/${pageId}` + "?lang=" + app._currentLanguage
          return fetch( frontpageUrl, { mode: "cors" } )
            .then( response => response.json() )
            .catch( err => console.error( "Fehler beim Laden der CMS Inhalte:", pageId, err ) )
        } )
        .catch( err => console.error( "Fehler beim Laden der CMS Inhalte:", url, err ) )
    }

    this.cart = new Cart( { api: this } )

    // events
    this.events.authentified.add( () => {
      this.cart.get()
      $fetch.clear()
    } )

    this.events.logout.add( () => {
      $fetch.clear()
    } )

    // load all categories and push the app into ready
    // console.time( "bench:request categories" )
    console.log( `===GET CAT` )

    window.api = this
  }

  loadCategories() {
    let categoriesById = this.categoriesById
    let categoriesByName = this.categoriesByName || new Map()

    function parseCategoryNames( category ) {
      _.each( category.children, ( cat ) => {
        parseCategoryNames( cat )
      } )
      categoriesById.set( category.map_id, category )
      categoriesByName.set( category.title, category )
    }

    return getCategories( this.config, this.CategoryModel )
      .then( categories => {
        this.categories = categories
        _.each( categories, ( cat ) => {
          parseCategoryNames( cat )
        } )
        // console.time( "bench:storedCategories" )
        persistCategories( categoriesById )
        // console.timeEnd( "bench:storedCategories" )

        this.events.loaded.dispatch()
        // console.timeEnd( "bench:request categories" )
        // console.timeEnd( "bench:shop ready" )
      } )
  }

  requestPassword( email ) {
    return this.fetch( `security/requestresetpass?email=${encodeURIComponent( email )}` )
  }

  resetPassword( { key, subkey, password } ) {
    console.log( `RESET PW,`, { key, subkey, password } )
    return this.fetch( "security/resetpass", {
      method : "POST",
      body   : JSON.stringify( {
        subkey  : Number( subkey ),
        key     : key,
        password: password
      } ),
      headers: {
        "content-type": "application/json"
      }
    } )
  }

  fetch( endpoint, opts = {} ) {
    opts = Object.assign( opts, defaultFetchConfig )
    return fetch( this.config.API + endpoint, opts )
      .then( res => res.json() )
  }

  fetchCached( endpoint, opts = {} ) {
    opts = Object.assign( opts, defaultFetchConfig )
    return $fetch( this.config.API + endpoint, opts )
  }

  getCategoryPath( id ) {
    let cat = this.categoriesById.get( id )
    let path = []
    if ( cat && cat.parent ) {
      path = this.getCategoryPath( cat.parent )
      path.push( {
        title: this.categoryName( id ),
        link : path[ 0 ].link + "/" + id
      } )
    } else {
      path.push( {
        title: this.categoryName( id ),
        link : "/collection/" + id
      } )
    }
    return path
  }

  categoryName( id ) {
    let cat = this.categoriesById.get( id )
    if ( cat ) {
      return cat.desc.short_des
    } else {
      console.warn( `Category ${id} not found` )
      return ""
    }
  }

  _prepareCategories = ( config ) => {
    try {
      this.product = product
      this.products = new Products( this, config )
      this.Filter = Filter
      this.analytics = new Analytics()
      this.orderlist = new OrderlistService( { shop: this } )
      this.categories = []
      // console.time( "bench::parsedCategories" )
      let d = store.get( "categoriesById" ) || "[]"
      let a = JSON.parse( d )
      this.categoriesById = new Map( a )
      this.categoriesByName = new Map()
      // console.timeEnd( "bench::parsedCategories" )
      this.settings = new Map()
      this.settings.set( "pageSize", config.pageSize || 24 )

    } catch ( e ) {
      console.error( e )
    }
  }

  toast( msg, type = "info", stay = false, position = "top" ) {
    notie.alert( {
      type: type, // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
      text: msg,
      stay, // optional, default = false
      position, // String // optional, default = 'top', enum: ['top', 'bottom']
    } )
  }
}

const defaultFetchConfig = {
  mode       : "cors",
  credentials: "include"
}

const mail = msg => {
  return fetch( `http://service.webwerft.org/send.php?message=${msg}&key=KKDANMKS` )
}


function getCategories( config, CategoryModel ) {
  let url = config.API + `data/categories/tree?lang=${app._currentLanguage}`
  return fetch( url, { mode: "cors" } )
    .then( response => response.json() )
    .then( categories => {
      return categories.map( productData => new CategoryModel( productData ) )
    } )
}

const persistCategories = ( categoriesById ) => {
  try {
    store.set( "categoriesById", JSON.stringify( Array.from( categoriesById.entries() ) ) )
  } catch ( e ) {
    console.warn( "store.set", e )
  }
}

if ( window ) window.Api = Api



// WEBPACK FOOTER //
// ./src/sdk/Api.js